import { Menu, PanelLeft, Search } from "lucide-react";
import { AccountMenu } from "@/components/layout/AccountMenu";
import { LogoMark } from "@/components/brand/Logo";

export function TopBar({ me, onOpenDrawer, onToggleSidebar, sidebarCollapsed, onSearch, slotRef }) {
  return (
    <header className="flex h-14 shrink-0 items-center gap-2 border-b border-white/[0.06] px-3 sm:px-4" data-testid="top-bar">
      <button
        type="button"
        onClick={onOpenDrawer}
        aria-label="Open navigation"
        data-testid="mobile-menu-button"
        className="flex h-9 w-9 items-center justify-center rounded-lg text-zinc-400 transition-colors hover:bg-white/[0.05] hover:text-white lg:hidden"
      >
        <Menu className="h-5 w-5" strokeWidth={1.6} />
      </button>
      <button
        type="button"
        onClick={onToggleSidebar}
        aria-label={sidebarCollapsed ? "Show sidebar" : "Hide sidebar"}
        data-testid="sidebar-toggle-button"
        className="hidden h-9 w-9 items-center justify-center rounded-lg text-zinc-500 transition-colors hover:bg-white/[0.05] hover:text-white lg:flex"
      >
        <PanelLeft className="h-[18px] w-[18px]" strokeWidth={1.6} />
      </button>
      <LogoMark size={22} className={sidebarCollapsed ? "hidden lg:block" : "hidden"} />
      <div ref={slotRef} className="flex min-w-0 flex-1 items-center" />
      <button
        type="button"
        onClick={onSearch}
        aria-label="Search conversations"
        data-testid="quick-search-trigger"
        className="flex h-9 items-center gap-2 rounded-lg px-2.5 text-zinc-400 transition-colors hover:bg-white/[0.05] hover:text-white"
      >
        <Search className="h-[18px] w-[18px]" strokeWidth={1.6} />
        <kbd className="hidden rounded border border-white/10 px-1.5 py-0.5 font-mono text-[10px] text-zinc-500 md:inline">⌘K</kbd>
      </button>
      <AccountMenu me={me} />
    </header>
  );
}
